module.exports = __webpack_public_path__ + "img/icon-info-circle.afd61b3f.svg";